import React, {useContext, useEffect, useState} from 'react';
import {Row, Col, Container, Form} from "react-bootstrap";
import useWindowDimensions from "../../hooks/Dimensions";
import ActionModal from "../../components/ActionModal";
import {WiresPanelContext} from "./context";
import {SecurityContext} from "context/security";
import AuthenticationService from "service/AuthenticationService";
import {EntityAccountsContext} from "components/entity-accounts/context";
import * as URL from "../../service/UrlConstant";
import {WIRE_PANEL_HOME_PAGE, WIRE_PANEL_VIEW_WIRE_PAGE} from "./context/WiresPanelContext";
import {ToastContext} from "../../context/Toast";
import {
    dateToString,
    getCurrentDateToDatePickerFormat,
    getPreviousDateToDatePickerFormat
} from "../../utils/FormatUtils";
import {validateValueOnRegex} from "../../utils/RegexUtils";
import {
    REGEX_DECIMAL_MATCH,
    REGEX_WIRES_NEW_CLIENT_CODE,
    REGEX_WIRES_NEW_OUTGOING_CURRENCY_CODE,
    REGEX_WIRES_NEW_REASON,
    REGEX_WIRES_NEW_TEMPLATE_NAME,
    REGEX_WIRES_NEW_WIRE_INST, SELECTED_ACCOUNT, VALIDATION_IN_JS
} from "../../utils/Constants";
import {
    REGEX_WIRES_NEW_CLIENT_CODE_MSG,
    REGEX_WIRES_NEW_OUTGOING_CURRENCY_CODE_MSG,
    REGEX_WIRES_NEW_REASON_MSG,
    REGEX_WIRES_NEW_TEMPLATE_NAME_MSG,
    REGEX_WIRES_NEW_WIRE_INST_MSG,
    WIRES_NEW_OUTGOING_VALUE_ZERO_ERROR
} from "../../utils/ConstantsMsg";
import {getAllErrorValuesAsString} from "../../utils/ErrorUtils";
import {CustomSelect} from "../../components/CustomSelect";
import {setSessionAttribute} from "../../utils/SessionUtils";

export default function AddNewWire(props) {
    const {isDesktop, isTab,isMobile} = useWindowDimensions();
    const bodyStyle=isDesktop?{paddingTop:0}:{};

    const {entityAccountsOptionsNoSwap, accountsOptionsNoSwap, entityAccountsNoSwap, setManagerDetails, setAccountDetails,validateEntityAccountSearch} = useContext(EntityAccountsContext);
    const {makePostRequest,makeGetRequest} = useContext(SecurityContext);
    const {wireNewState, setWireNewState,clearWireNewState,displayWirePanelPage,wirePanelPageState,wireResultsDisplayState,setWireResultsDisplayState, wireTemplatesList, setWireTemplatesList, wireCurrenciesList, setWireCurrenciesList, isWireSubmissionAllowedForAccount,
        disableRequestWires} = useContext(WiresPanelContext);
    const [formErrors, setFormErrors] = useState({search: {}});
    const {success,error} = useContext(ToastContext);
    const [options, setOptions] = useState([]);
    const [localEntityAccountsOptions,setLocalEntityAccountsOptions] = useState(JSON.parse(JSON.stringify(entityAccountsOptionsNoSwap)))
    const [selectedOption,setSelectedOption] = useState({})
    let userName = AuthenticationService.getAuthenticatedUserName();

    const resetTemplateSelection = (state) => ({
        ...state,
        idTemplate: '',
        templateName: '',
        instructions: '',
        indTemplate: 'N'
    });

    const getCurrencies = () => {

        if (wireNewState.managerName == null  || wireNewState.managerName == "") {
            return;
        }

        const params = {
            manager:wireNewState.managerName
        };
        const onSuccess = (response) => {
            setWireCurrenciesList(response.data)
        }
        const onError = (err) => {
            console.error(err);
        }
        makeGetRequest(URL.WIRES_CURRENCY_URL, params,onSuccess, onError);
    }

    const getWireTemplates = () => {
        if (!entityAccountsNoSwap.managerId || !entityAccountsNoSwap.accountId || !wireNewState.outgoingCcy) {
            return;
        }

        const settlementCurrency = wireNewState.outgoingCcy;
        const params = {
            idManager: entityAccountsNoSwap.managerId,
            idAccount: entityAccountsNoSwap.accountId,
            settlementCurrency,
        };
        const onSuccess = (response) => {
            const filteredTemplates = (response.data || []).filter(template => template.settlementCurrency === settlementCurrency);
            setWireTemplatesList(filteredTemplates)
        }
        const onError = (err) => {
            console.error(err);
        }
        makeGetRequest(URL.WIRE_TEMPLATE_SEARCH_APPROVE_URL, params, onSuccess, onError);
    }

    const handleChange = (e,name) => {
        if(name === 'thirdPartyCode')
        {
            if(e.currentTarget.id ==='3rd-radio-yes' && e.currentTarget.checked === true)
                setWireNewState({...wireNewState, ['thirdPartyCode']:"Y"});
            else if(e.currentTarget.id ==='3rd-radio-no' && e.currentTarget.checked === true)
                setWireNewState({...wireNewState, ['thirdPartyCode']:"N"});
        }
        else {
            if (e.currentTarget.name === 'outgoingCcy') {
                setWireTemplatesList([]);
                setWireNewState(resetTemplateSelection({...wireNewState, [e.currentTarget.name]:e.currentTarget.value}));
            }
            else {
                setWireNewState({...wireNewState, [e.currentTarget.name]:e.currentTarget.value});
            }
            formErrors.search[name] = '';
        }
    }

    const handleTemplateChange = (e) =>{
        if(e.currentTarget !== null) {
            const selectedIndex = e.currentTarget.selectedIndex;
            const keySelected = e.currentTarget[selectedIndex].value;
            const selectedTemplate = wireTemplatesList.find(template => template.idTemplate.toString() === keySelected.toString());

            const wireNewStateUpdated = JSON.parse(JSON.stringify(wireNewState));
            if (keySelected == "-1") {
                wireNewStateUpdated[e.currentTarget.name] = "";
                wireNewStateUpdated["idTemplate"] = "";
                wireNewStateUpdated.instructions = "";
            }
            else if (selectedTemplate) {
                wireNewStateUpdated.instructions = selectedTemplate.wireInstructions;
                wireNewStateUpdated[e.currentTarget.name] = selectedTemplate.templateName;
                wireNewStateUpdated["idTemplate"] = keySelected;
                wireNewStateUpdated["indTemplate"] = "N";
                formErrors.search.instructions = '';
                formErrors.search.templateName = '';
            }

            setWireNewState(wireNewStateUpdated);
        }
    }

    const handleManagerChange = (e,name) => {
        const managerId = e.currentTarget.value;
        const managerToSelect = entityAccountsOptionsNoSwap.find(manager => manager.managerId.toString() === managerId);
        if(managerToSelect) {
            setManagerDetails(e.target.value, e.currentTarget.options[e.currentTarget.selectedIndex].innerHTML,true);
            formErrors.search.entity = '';
            setWireTemplatesList([]);

            setWireNewState(
                resetTemplateSelection({
                    ...wireNewState,
                    ['managerId']: managerId,
                    ['managerName']: managerToSelect.shortName,
                    ['accountId']: '',
                    ['accountName']: '',
                    ['clientCode']: ''
                }));
        } else {
            setManagerDetails('', '',true);
            formErrors.search.entity = '';
            setWireTemplatesList([]);

            setWireNewState(resetTemplateSelection({
                ...wireNewState,
                accountId: '',
                accountName: '',
                clientCode: '',
                managerId: '',
                managerName: '',
            }));
        }
    }

    const handleChangeAutocomplete = (e)=>{
        formErrors.search.entity = ''
        setManagerDetails(e.value, e.label,true);
        setWireTemplatesList([]);

        setWireNewState(
            resetTemplateSelection({
                ...wireNewState,
                ['managerId']: e.value,
                ['managerName']: e.label,
                ['accountId']: '',
                ['accountName']: '',
                ['clientCode']: ''
            }));
    }
    const handleInputChangeAutoComplete = (enteredValue)=>{
        formErrors.search.entity = ''

        const newData = entityAccountsOptionsNoSwap.filter(e=> {
                return e.shortName.toLowerCase().includes(enteredValue.toLowerCase()) || e.longName.toLowerCase().includes(enteredValue.toLowerCase())
            }
        )

        setLocalEntityAccountsOptions(newData);
    }

    const handleAccountChange = (e,name) => {

        const accountId = e.target.value;
        const accountToSelect = accountsOptionsNoSwap.find(account => account.accountId.toString() === accountId);

        if(accountToSelect) {
            setAccountDetails(accountToSelect.accountId, accountToSelect.name, accountToSelect.accountCode,true);
            setSessionAttribute(SELECTED_ACCOUNT, accountToSelect);
            formErrors.search.account = '';
            setStateBasedOnAccount(accountToSelect.accountId,accountToSelect.accountCode, accountToSelect.name)
            isWireSubmissionAllowedForAccount()
        }
        else{
            setAccountDetails('','',null,true);
            setStateBasedOnAccount(null,null,null)
            setWireNewState(prevState => ({
                ...prevState,
                outgoingCcy: '',
            }));
        }

}

    const validateAddWireRequired = ()=> {
        let errors = {}
        if (!wireNewState.managerId || wireNewState.managerId === '') {
            errors['entity'] = 'Please select entity'
        }

        if (!wireNewState.accountId || wireNewState.accountId === '') {
            errors['account'] = 'Please select account'
        }

        if (!wireNewState.reason) {
            errors['reason'] = 'Please enter reason'
        }

        if (!wireNewState.templateName || wireNewState.templateName == "") {
            errors['templateName'] = 'Please select a template'
        }

        if (!wireNewState.instructions) {
            errors['instructions'] = 'Please enter instructions'
        }
        return errors
    }
    const validateAddWireRegex = ()  => {
        let errors = {}
        if (wireNewState.reason){
            let match = validateValueOnRegex(wireNewState.reason,REGEX_WIRES_NEW_REASON)
            if (!match){
                errors['reason'] = REGEX_WIRES_NEW_REASON_MSG
            }
        }
        if (wireNewState.templateName){
            //const instructions = getTemplateNameWithoutAccountData(wireNewState.templateName)
            const instructions = wireNewState.templateName
            let match = validateValueOnRegex(instructions,REGEX_WIRES_NEW_TEMPLATE_NAME)
            if (!match){
                errors['templateName'] = REGEX_WIRES_NEW_TEMPLATE_NAME_MSG
            }
        }
        if (wireNewState.instructions){
            let match = validateValueOnRegex(wireNewState.instructions,REGEX_WIRES_NEW_WIRE_INST)
            if (!match){
                errors['instructions'] = REGEX_WIRES_NEW_WIRE_INST_MSG
            }
        }
        if (wireNewState.outgoingCcy){
            let match = validateValueOnRegex(wireNewState.outgoingCcy,REGEX_WIRES_NEW_OUTGOING_CURRENCY_CODE)
            if (!match){
                errors['outgoingCcy'] = REGEX_WIRES_NEW_OUTGOING_CURRENCY_CODE_MSG
            }
        }
        if (wireNewState.clientCode){
            let match = validateValueOnRegex(wireNewState.clientCode,REGEX_WIRES_NEW_CLIENT_CODE)
            if (!match){
                errors['account'] = REGEX_WIRES_NEW_CLIENT_CODE_MSG
            }
        }
        return errors
    }

    // check outgoing value and currencies relations
    // outgoing value must be > 0 and only one
    // if outgoing value is valid, need outgoing currency is selected
    const validateAddWireMoneyOut = () => {
        let errors = {}
        let moneyOutFloat = wireNewState.moneyOut?parseFloat(wireNewState.moneyOut):0.00

        let moneyOutExist = moneyOutFloat > 0.00
        let moneyOutZero = (Math.abs(moneyOutFloat) < 0.000001)
        let moneyOutNegative = moneyOutFloat < 0.00
        let msg = ""
         if (moneyOutZero){
             msg = WIRES_NEW_OUTGOING_VALUE_ZERO_ERROR
             errors["moneyOut"] = msg
         } else {
             // check moneyOutCurrency
             if (!wireNewState.outgoingCcy){
                 errors["outgoingCcy"] = "Please select Outgoing Currency"
             }
        }

         // check negative
        if (moneyOutNegative){
            errors["moneyOut"] = "Outgoing value should be greater than 0"
        }

        return errors
    }

    const validateAddWire = ()=> {
        let errors = validateAddWireRequired()

        // regex validation
        let errorsRegex = validateAddWireRegex()
        errors = {...errors, ...errorsRegex}
        // check outgoing value and currencies relations
        let errorsMoneyOut = validateAddWireMoneyOut()
        errors = {...errors, ...errorsMoneyOut}

        return errors
    }

    const handleViewWires = () =>{

        const params = {
            idManager: entityAccountsNoSwap.managerId,
            idAccount: entityAccountsNoSwap.accountId,
            startDate: dateToString(getPreviousDateToDatePickerFormat()),
            endDate:dateToString(getCurrentDateToDatePickerFormat()),
            status:"ALL",
        }

        const onSuccess = (res) => {
            const wireResultsDisplay = JSON.parse(JSON.stringify(wireResultsDisplayState));
            wireResultsDisplay.resData = ([...res.data]);
            wireResultsDisplay.isSavedWire = false;
            wireResultsDisplay.savedName = "";
            wireResultsDisplay.savedWireListId = "";
            wireResultsDisplay.wireSearch = {
                userCode:'',
                managerId: entityAccountsNoSwap.managerId,
                managerName : entityAccountsNoSwap.managerName,
                accountId: entityAccountsNoSwap.accountId,
                accountName : entityAccountsNoSwap.accountName,
                accountCode : entityAccountsNoSwap.accountCode,
                subManagerId : entityAccountsNoSwap.subManagerId,
                subManagerName : entityAccountsNoSwap.subManagerNameShort,
                legalEntity:'',
                clientCode: entityAccountsNoSwap.accountCode,
                status: "ALL",
                startDate:dateToString(getPreviousDateToDatePickerFormat()),
                endDate:dateToString(getCurrentDateToDatePickerFormat()),
                badgeInfo: !!entityAccountsNoSwap.accountCode?entityAccountsNoSwap.accountCode+'-'+entityAccountsNoSwap.accountName:entityAccountsNoSwap.accountName
            };
            setWireResultsDisplayState(wireResultsDisplay);
            props.onHide();
            clearWireNewState();
            displayWirePanelPage(WIRE_PANEL_VIEW_WIRE_PAGE);
        }
        const onError = (err) => {
            console.error('Error when retrieving wires - ', err);
            props.onHide();
            clearWireNewState();
           // error("There was an error when loading wires !!");
        }
        makePostRequest(params, URL.WIRES_WIRE_SEARCH, onSuccess, onError);
    }

    const handleCancelWires = (e) => {
        clearWireNewState();
        props.onHide();
    }
    const handleAddWires = (e) => {
        e.preventDefault();

        let errors = {}
        if (VALIDATION_IN_JS){
            errors = validateAddWire()
        }
        const newFormErrors = {...formErrors}
        newFormErrors['search'] = errors;
        setFormErrors(newFormErrors)

        if (Object.keys(errors).length !== 0) {
            return
        }

        const params = {
            idAccount:wireNewState.accountId,
            cdClient:wireNewState.clientCode,
            idManager:wireNewState.managerId,
            thirdParty: wireNewState.thirdPartyCode,
            mnyOut: parseFloat(wireNewState.moneyOut !="" ?wireNewState.moneyOut:0.00),
            ccyOut:wireNewState.outgoingCcy,
            reason:wireNewState.reason,
            wireInstructions: wireNewState.instructions,
            idTemplate: wireNewState.idTemplate,
            indStatus:"PEND"
        }

        const onSuccess = (res) => {
            success("Wire Created Successfully !!")
            //TODO: Validate this logic
            if(WIRE_PANEL_VIEW_WIRE_PAGE === wirePanelPageState.currentPage) {
                handleViewWires();
            }
            else {
                displayWirePanelPage(WIRE_PANEL_HOME_PAGE)
                props.onHide();
                clearWireNewState();
            }
        }
        const onError = (err) => {
            let errorMsg = getAllErrorValuesAsString(err.response.data)
            console.error('Error when adding new wire - ', errorMsg);
            error("Error when adding new wire")
        }

        makePostRequest(params,URL.WIRES_SAVE_URL, onSuccess, onError);

    }

    function getTemplateNameWithoutAccountData(templateName) {
        if (templateName === null) {
            return templateName;
        }
        let index = templateName.indexOf("- ");
        if (index > 0) {
            return templateName.slice(index + 2);
        }
    }

    useEffect( () =>{
        if(entityAccountsNoSwap.managerId && entityAccountsNoSwap.accountId && wireNewState.outgoingCcy) {
            getWireTemplates();
        }
        else {
            setWireTemplatesList([]);
        }
    },[entityAccountsNoSwap.managerId, entityAccountsNoSwap.accountId, wireNewState.outgoingCcy])

    useEffect(() => {
        getCurrencies();
    },[wireNewState.managerName])

    useEffect(()=>{
        setLocalEntityAccountsOptions(JSON.parse(JSON.stringify(entityAccountsOptionsNoSwap)))
    },[entityAccountsOptionsNoSwap])

    useEffect(()=>{

        const options = []
        entityAccountsOptionsNoSwap.map(e=>{
            let option = {}
            option['value'] = e.managerId
            option['label'] = e.shortName+'-'+e.longName
            options.push(option)
        })
        setOptions(options)
    },[localEntityAccountsOptions])

    useEffect(()=>{
        const selectedEntity = options.filter(e=>e.value===Number(wireNewState.managerId))
        if(selectedEntity.length>0)
        {
            setSelectedOption(selectedEntity[0]);
        }
        else{
            setSelectedOption({})
        }

    },[options, wireNewState])

    const modalBody = () => (
        <Container fluid>
            <Row style={{paddingBottom:0}}>
                <Col style={{paddingBottom:0}}>
                    <Container fluid>
                        <Row>
                            <Col md={6}>
                                <Form.Group controlId="formGridState" id={(!!formErrors.search.entity? 'td-select-error':'')}>
                                    <Form.Label className="filter-input-label">* Entity</Form.Label>

                                    <CustomSelect
                                        isDisabled={false}
                                        placeholder={'Select'}
                                        options={options}
                                        value={Object.keys(selectedOption).length > 0?selectedOption:null}
                                        onChange={handleChangeAutocomplete}
                                        onInputChange={handleInputChangeAutoComplete}
                                        isValid={!formErrors.search.entity}
                                        className={!entityAccountsNoSwap.formErrors.search.entity?'is-invalid invalid':''}
                                        addNewWireModal={true}
                                       />


                                    {!!entityAccountsNoSwap.formErrors.search.entity &&
                                    <Form.Control.Feedback type={'invalid'}>
                                        <b><i className="bi bi-exclamation-circle"></i>{formErrors.search.entity}</b>
                                    </Form.Control.Feedback>
                                    }
                                </Form.Group>
                            </Col>
                            {entityAccountsNoSwap.showAccounts &&
                            <Col md={6}>
                                <Form.Group controlId="formGridState" className={'td-select'} id={(!!formErrors.search.account? 'td-select-error':'')}>
                                    <Form.Label className="filter-input-label">* Account</Form.Label>
                                    <Form.Control as="select" name='accounts' value={entityAccountsNoSwap.accountId || ''} onChange={event => handleAccountChange(event, 'accounts')}
                                                  isInvalid={!!formErrors.search.account}>
                                        <option value={''}>Select</option>
                                        {accountsOptionsNoSwap &&
                                        accountsOptionsNoSwap.map((account) => <option key={account.accountId} value={account.accountId}>{account.accountCode}-{account.name}</option>)}
                                    </Form.Control>
                                    <Form.Control.Feedback type={'invalid'}>
                                        <b><i className="bi bi-exclamation-circle"></i>{formErrors.search.account}</b>
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            }
                        </Row>
                    </Container>
                </Col>
            </Row>

            <Row  style={{paddingTop:0}}>
                <Col style={{paddingTop:0}}>
                    <Container fluid>
                        <Row className="align-items-center">
                            <Col xs={"auto"} style={{alignSelf:"center"}}>
                                <b style={{whiteSpace:"nowrap"}}>* 3rd party</b>
                            </Col>
                            <Col xs={"auto"} style={{alignSelf:"center"}}>
                                <Form.Check
                                    name='thirdPartyCode'
                                    type='radio'
                                    id={'3rd-radio-yes'}
                                    label={"Yes"}
                                    onChange={event => handleChange(event, 'thirdPartyCode')}
                                    checked={wireNewState.thirdPartyCode==='Y'}
                                />
                            </Col>
                            <Col xs={"auto"} style={{alignSelf:"center"}}>
                                <Form.Check
                                    name='thirdPartyCode'
                                    type='radio'
                                    id={'3rd-radio-no'}
                                    label={"No"}
                                    onChange={event => handleChange(event, 'thirdPartyCode')}
                                    checked={wireNewState.thirdPartyCode==='N'}
                                />
                            </Col>
                        </Row>
                    </Container>
                </Col>
            </Row>

            <Row>
                <Col style={{paddingBottom:0}}>
                    <Container fluid>
                        <Row>
                            <Col sm={12} md={6}>
                                <Form.Group controlId="formGridState">
                                    <Form.Label className="filter-input-label">Outgoing Value</Form.Label>
                                    <Form.Control placeholder="0.00" name='moneyOut' value={wireNewState.moneyOut} pattern={REGEX_DECIMAL_MATCH} onChange={event => handleChange(event, 'moneyOut')}
                                          isInvalid={!!formErrors.search.moneyOut} />
                                    <Form.Control.Feedback type={'invalid'}>
                                        <b><i className="bi bi-exclamation-circle"></i>{formErrors.search.moneyOut}</b>
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>

                            <Col sm={12} md={6}>
                                <Form.Group controlId="formGridState" className={'td-select'} id={(!!formErrors.search.outgoingCcy? 'td-select-error':'')}>
                                    <Form.Label className="filter-input-label">* Outgoing Currency</Form.Label>
                                    <Form.Control as="select" name ='outgoingCcy' value={wireNewState.outgoingCcy} onChange={event => handleChange(event, 'outgoingCcy')}
                                        isInvalid={!!formErrors.search.outgoingCcy}>
                                        <option value="">Select</option>
                                        {wireCurrenciesList &&
                                        wireCurrenciesList.map((ccy) => <option key={ccy.currencyCode} value={ccy.currencyCode}>{ccy.currencyCode} - {ccy.currencyName} </option>)
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type={'invalid'}>
                                        <b><i className="bi bi-exclamation-circle"></i>{formErrors.search.outgoingCcy}</b>
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>

                            <Col sm={12} md={6}>
                                <Form.Group controlId="formGridState">
                                    <Form.Label className="filter-input-label">* Reason</Form.Label>
                                    <Form.Control name ='reason' value={wireNewState.reason} onChange={event => handleChange(event, 'reason')}
                                                  isInvalid={!!formErrors.search.reason}/>
                                    <Form.Control.Feedback type={'invalid'}>
                                        <b><i className="bi bi-exclamation-circle"></i>{formErrors.search.reason}</b>
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>

                            <Col sm={12} md={6}>
                                <Form.Group controlId="formGridState" className={'td-select'} id={(!!formErrors.search.templateName? 'td-select-error':'')}>
                                    <Form.Label className="filter-input-label">* Existing Template(s)</Form.Label>
                                    <Form.Control as="select" name ="templateName" value={wireNewState.idTemplate}
                                                  onChange={event => handleTemplateChange(event)}
                                                  isInvalid={!!formErrors.search.templateName}>
                                        <option value={'-1'}>Select</option>
                                        {wireTemplatesList &&
                                        wireTemplatesList.map((template) => <option key={template.idTemplate} value={template.idTemplate}>{template.templateName}</option>)
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type={'invalid'}>
                                        <b><i className="bi bi-exclamation-circle"></i>{formErrors.search.templateName}</b>
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>

                            <Col xs={12}>
                                <Form.Group controlId="formGridState">
                                    <Form.Label className="filter-input-label">* Wire Instructions</Form.Label>
                                    <Form.Control disabled={true} as="textarea" rows={6} name='instructions' value={wireNewState.instructions}
                                                  onChange={event => handleChange(event, 'instructions')}
                                                  isInvalid={!!formErrors.search.instructions}/>
                                    <Form.Control.Feedback type={'invalid'}>
                                        <b><i className="bi bi-exclamation-circle"></i>{formErrors.search.instructions}</b>
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Container>
                </Col>
            </Row>

            <Row className="pt-3">
                <Col></Col>
                <Col sm={12} md={6}>
                    <Container>
                        <Row>
                            <Col>
                                <button className="btn btn-block td-btn-secondary-clear" onClick={handleCancelWires}>Cancel</button>
                            </Col>
                            <Col>
                                <button className="btn btn-block td-btn-primary-light" disabled={disableRequestWires} onClick={handleAddWires}>Submit</button>
                            </Col>
                        </Row>
                    </Container>
                </Col>
            </Row>
        </Container>
    )

    const modalTitle = () => (
        <Container>
            <Row>
                <Col>Create New Wire</Col>
            </Row>
        </Container>
    )


function setStateBasedOnAccount(accountId, clientCode, accountName){
    setWireTemplatesList([]);
    setWireNewState(prevState =>
        resetTemplateSelection({
            ...prevState,
            'accountId':accountId,
            'clientCode':clientCode,
            'accountName':accountName
        })
    );
}

    return (<>
        <ActionModal body={modalBody} title={modalTitle} show={props.show} onHide={props.onHide} dialogClassName={isMobile? "mobile-fullscreen-dialog": (isTab ? "fullscreen-dialog" : "")} size={isDesktop?"lg":""} bodyStyle={bodyStyle} centered={true}></ActionModal>
    </>);
}
